import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_FILTER_CONFIG_PROPERTIES_QUERY_PARAMS } from "../api";
import { ConfigPropertyModalForm } from "../components/forms/ConfigPropertyModalForm";
import { ConfigPropertyFilterView } from "../components/views/ConfigPropertyFilterView";
import { ConfigPropertyTableView } from "../components/views/ConfigPropertyTableView";
import { DynamicConfigProperty, DynamicConfigPropertyFilterPageRequest } from "../types";

export const ConfigPropertyListContainer = () => {
  const searchParams = useFilterSearchParams<DynamicConfigPropertyFilterPageRequest>({
    params: ["ownedByIds"],
    defaultQueryParamsObject: DEFAULT_FILTER_CONFIG_PROPERTIES_QUERY_PARAMS,
  });

  const [configPropertyFormOpen, setConfigPropertyFormOpen] = useState(false);
  const [configPropertyToUpdate, setConfigPropertyToUpdate] = useState<DynamicConfigProperty>();

  const handleCreateClick = () => {
    setConfigPropertyFormOpen(true);
  };

  const handleUpdateClick = (property: DynamicConfigProperty) => {
    setConfigPropertyFormOpen(true);
    setConfigPropertyToUpdate(property);
  };

  const handleFormCancel = () => {
    setConfigPropertyFormOpen(false);
    setConfigPropertyToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <ConfigPropertyFilterView searchParams={searchParams} onCreateClick={handleCreateClick} />

      <ConfigPropertyTableView searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <ConfigPropertyModalForm
        open={configPropertyFormOpen}
        property={configPropertyToUpdate}
        onFormCancel={handleFormCancel}
      />
    </ContentWrapper>
  );
};
